import { Base } from './base.model';

export class AcrStrataVersion extends Base {
  public siteId: number;
  public version: number;
  public valuation: number;
  public area: number;
  public createDate: Date;
}
